<script>
  export function error(err) {
    var errorEl = document.createElement('div');
    errorEl.textContent = 'Error! ' + err.message;
    document.body.insertBefore(
      errorEl,
      document.body.firstChild
    );
  }
</script>


<div class="grid-container">
  <div class="grid-row padding-y-2 clearfix" style="align-content: end !important;">
    <button class="usa-button float-right" (click)="initiateSSO()">GSA Employee Login</button>
  </div>
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
     <app-announcements [broadcastMessages]="broadCastMessages"></app-announcements>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
      <div class="usa-alert usa-alert--error usa-alert--slim" *ngIf="!isUserAgentChrome">
        <div class="usa-alert__body">
          <p class="usa-alert__text">This website is best viewed in Chrome Browser</p>
        </div>
      </div>

      <div class="usa-alert usa-alert--error usa-alert--slim margin-right-1 margin-left-1" role="alert" *ngIf="errorMessage">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            {{errorMessage}}
          </p>
        </div>
      </div>
      <div class="usa-card padding-top-2">
        <div class="usa-card__container">
          <header class="usa-card__header">
            <h2 class="usa-card__heading">GSA Multi-Factor Authentication (MFA) - Sign In</h2>
          </header>
          <div class="usa-card__body">
            <div id="okta-sign-in" class="w-100 bg-white border-0 m-0"></div>
          </div>
          <div class="usa-card__footer">
            For help with TMSS 2.0 or to change the way you currently receive the required "Code" (SMS/Text, Voice,
            Email, Authenticator App etc.),
            Please contact: 1-866-668-3472 or email: <a
            href="mailto:gsamovehelp@gsa.gov" style="font-weight:bold">gsatmsshelp&#64;gsa.gov</a> for assistance
          </div>
        </div>
      </div>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    </div>
  </div>
</div>
